import { useHistory } from 'react-router-dom';

import { ICustomUtilsHistory } from './types';

export const useCustomUtilsHistory = (): ICustomUtilsHistory => {
  return useHistory() as ICustomUtilsHistory;
};
